var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y303vf2oea)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.46 12.288a.717.717 0 0 0 .106-.009l3.004-.527a.175.175 0 0 0 .095-.05l7.57-7.57a.178.178 0 0 0 0-.251L11.265.91A.177.177 0 0 0 11.14.86a.177.177 0 0 0-.127.052l-7.57 7.57a.181.181 0 0 0-.05.094l-.527 3.004a.599.599 0 0 0 .168.532.605.605 0 0 0 .425.177zm1.203-3.114 6.477-6.475 1.308 1.309-6.476 6.475-1.588.28.279-1.59zm9.909 4.614H1.429a.57.57 0 0 0-.572.571v.643c0 .079.065.143.143.143h14a.143.143 0 0 0 .143-.143v-.643a.57.57 0 0 0-.571-.571z",
    fill: "#096DD9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "y303vf2oea"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.2a9c947bf25a7ac8fd648fe73e7f742c.svg";
export { ForwardRef as ReactComponent };